export class UpdateThreatHuntingScanRequestRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "customRule",
            "baseName": "customRule",
            "type": "string",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return UpdateThreatHuntingScanRequestRequest.attributeTypeMap;
    }
    constructor() {
    }
}
